{
  "title": "Acceso",
  "subtitlePlatform": "Todos los que han iniciado sesión en el portal. Quien entra sin invitación aparece aquí sin roles y permanece en la pantalla de espera de acceso hasta que se le conceda algo.",
  "subtitleTenant": "Personas que pueden acceder a este inquilino. Invita a alguien que aún no haya iniciado sesión, o concede acceso a quien ya lo haya hecho.",
  "partnerTitle": "Equipo del partner",
  "partnerSubtitle": "Personas que pueden administrar este libro de partner: invitar clientes, gestionar firmas y invitar a otros administradores del partner.",
  "partnerInviteHint": "Se convierten en administradores del partner para este libro. Basta con iniciar sesión: el rol se aplica la primera vez que llegan.",
  "nobodyYetPartner": "Aún no hay administradores del partner aparte de invitaciones pendientes. Invita a un colega con la dirección con la que iniciará sesión.",
  "inviteSomebody": "Invitar a alguien",
  "grantAccess": "Conceder acceso",
  "waitingTitle": "Pendientes de aceptar",
  "waitingHint": "El rol se aplica automáticamente en su primer inicio de sesión.",
  "invitationsAria": "Invitaciones pendientes",
  "colInvited": "Invitado",
  "colExpires": "Caduca",
  "colWillReceive": "Recibirá",
  "invitedBy": "por {{name}}",
  "withdraw": "Retirar",
  "withdrawAria": "Retirar la invitación de {{email}}",
  "notWithdrawn": "No retirada",
  "withdrawError": "No se pudo retirar esa invitación.",
  "nobodyYet": "Nadie todavía",
  "nobodyYetTenant": "Nadie tiene acceso a este inquilino. Invita a alguien y el acceso estará listo en su primer inicio de sesión.",
  "nobodyYetPlatform": "Nadie ha iniciado sesión aún. Invita a alguien con la dirección con la que entrará y su rol se aplicará al llegar.",
  "peopleAria": "Personas",
  "colPerson": "Persona",
  "colLastSignIn": "Último acceso",
  "colAccess": "Acceso",
  "notRevoked": "No revocado",
  "revokeError": "No se pudo revocar.",
  "noAccessYet": "Sin acceso aún",
  "revoke": "Revocar",
  "revokeOwnerOnly": "Solo un propietario de plataforma puede revocar la propiedad",
  "revokeAria": "Revocar {{role}}{{tenant}}",
  "onTenant": " en {{name}}",
  "nobodyToGrant": "Aún no hay a quién conceder acceso: esta lista son personas que ya han iniciado sesión. Invítalos y el rol se aplicará al llegar.",
  "personPlaceholder": "Elige a alguien que haya iniciado sesión",
  "role": "Rol",
  "rolePlaceholder": "Elige un rol",
  "tenant": "Inquilino",
  "tenantPlaceholder": "Elige un inquilino",
  "grant": "Conceder",
  "accessGranted": "Acceso concedido.",
  "notGranted": "No concedido",
  "grantError": "No se pudo conceder.",
  "inviteTitle": "Invitar a alguien",
  "inviteHint": "No necesitan una cuenta aquí. Basta con iniciar sesión: el rol de abajo se aplica la primera vez que llegan.",
  "workEmail": "Correo laboral",
  "workEmailDesc": "La dirección con la que iniciarán sesión.",
  "differentOrg": "Inician sesión desde otra organización",
  "differentOrgDesc": "Márcalo para el administrador propio de un cliente. Déjalo sin marcar para un colega.",
  "theirDirectory": "Su directorio",
  "theirDirectoryPlaceholder": "Id. de inquilino Entra, o dominio de Google Workspace",
  "theirDirectoryDesc": "Se pide porque un correo solo no prueba nada: cualquiera puede crear esa dirección en un directorio que controla. La invitación solo funciona desde el directorio indicado aquí.",
  "sendInvitation": "Enviar invitación",
  "invitedEmailed": "Invitado {{email}}. Se le ha enviado un correo.",
  "invitedNoEmailTitle": "Invitado {{email}}",
  "invitedNoEmailBody": "No se envió correo: este entorno no tiene correo saliente configurado. Diles que inicien sesión y su acceso estará listo.",
  "notInvited": "No invitado",
  "inviteError": "No se pudo invitar a esa persona.",
  "rolePlatformOwner": "Propietario de plataforma",
  "rolePlatformAdmin": "Administrador de plataforma",
  "rolePartnerAdmin": "Administrador del partner",
  "roleTenantAdmin": "Administrador de inquilino",
  "roleEditor": "Editor",
  "roleDesigner": "Diseñador",
  "roleViewer": "Visor",
  "roleDescOwner": "Todo, incluida la concesión de propiedad a otros.",
  "roleDescAdmin": "Administra todos los inquilinos. No puede conceder roles de plataforma.",
  "roleDescPartnerAdmin": "Administra cada cliente de este libro de partner, y quién más puede gestionarlo.",
  "roleDescTenantAdmin": "Control total de un inquilino, incluida su lista de acceso.",
  "roleDescEditor": "Edita plantillas, reglas y campañas.",
  "roleDescDesigner": "Solo edita plantillas.",
  "roleDescViewer": "Solo lectura."
}
